import React from "react";
import ReactDOM from "react-dom/client";
import OrderSurveyPopup from "../components/surveys/OrderSurveyPopup";

class SurveyManager {
  constructor() {
    this.STORAGE_KEY = "showOrderSurvey";
    this.DISPLAY_TIMEOUT = 5 * 60 * 1000; // 5 minutes
    this.surveyRoot = null;
  }
  // Manages NPS survey popup display after order submission

  triggerSurvey(orderId, companyCode) {
    localStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify({
        timestamp: Date.now(),
        orderId: orderId,
        companyCode: companyCode,
        shown: false,
      })
    );
  }

  checkAndDisplay() {
    const surveyData = localStorage.getItem(this.STORAGE_KEY);

    if (!surveyData) return;

    const { timestamp, companyCode, shown } = JSON.parse(surveyData);

    // Only display if not shown and within timeout window
    if (!shown && Date.now() - timestamp < this.DISPLAY_TIMEOUT) {
      this.displaySurvey(companyCode);

      // Mark as shown
      localStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify({
          ...JSON.parse(surveyData),
          shown: true,
        })
      );
    } else if (Date.now() - timestamp >= this.DISPLAY_TIMEOUT) {
      // Clean up expired data
      localStorage.removeItem(this.STORAGE_KEY);
    }
  }

  displaySurvey(companyCode) {
    if (this.surveyRoot) return;

    // Create container for React component
    const container = document.createElement("div");
    container.id = "au-survey-react-root";
    document.body.appendChild(container);

    // Create React root and render component
    this.surveyRoot = ReactDOM.createRoot(container);
    this.surveyRoot.render(
      React.createElement(OrderSurveyPopup, {
        open: true,
        onClose: () => this.dismiss(),
        companyCode: companyCode,
      })
    );
  }

  dismiss() {
    // Unmount React component
    if (this.surveyRoot) {
      this.surveyRoot.unmount();
      this.surveyRoot = null;
    }

    // Remove container
    document.querySelector("#au-survey-react-root")?.remove();

    // Keep the localStorage entry but marked as shown
    // This ensures it won't show again until a new prescription is sent
    const surveyData = localStorage.getItem(this.STORAGE_KEY);
    if (surveyData) {
      const data = JSON.parse(surveyData);
      localStorage.setItem(
        this.STORAGE_KEY,
        JSON.stringify({
          ...data,
          shown: true,
          dismissedAt: Date.now(),
        })
      );
    }
  }

  cleanup() {
    // Full cleanup - removes everything including localStorage
    if (this.surveyRoot) {
      this.surveyRoot.unmount();
      this.surveyRoot = null;
    }

    document.querySelector("#au-survey-react-root")?.remove();
    localStorage.removeItem(this.STORAGE_KEY);
  }
}

export default new SurveyManager();
